module.exports = "images/doc-cotation-add-2.bf12cf734b99c70f862a4f1da3920462.png";